/* =============================================================================
 * Enriched Product Description Standalone (epdsb4n7)
 *
 * Plain content block — no interactions to track. This file exists for two
 * reasons:
 *
 *   1. Snippet-library convention: every snippet ships a JS file alongside
 *      its main `.liquid` so the wrapper's `<script src=…>` tag always
 *      resolves.
 *   2. Per-instance bind handshake: calling `__spectrumAi.snippet.bind(node,
 *      callback)` lets the bootstrap SDK match the snippet instance to its
 *      analytics envelope (snippet_id, instance_id, experience_id, …) for
 *      the auto-fired `snippet:impression` baseline event.
 *
 * No custom events are emitted by this snippet. Only the baseline
 * impression fires — see packages/snippet-library/docs/long_description.analytics.md.
 *
 * No-bind fallback: if window.__spectrumAi is absent (theme without the
 * Spectrum app embed installed), the SSR'd content remains visible and
 * functional; analytics are silently skipped.
 *
 * Trust boundary:
 *   Backend-supplied HTML at entry.content.html is emitted raw by the
 *   server template. This file does not touch the body HTML.
 * ============================================================================= */

;(() => {
  if (window.__sai_epdsb4n7_initialized__) return
  window.__sai_epdsb4n7_initialized__ = true

  const SNIPPET_ID = 'epdsb4n7'

  function bindAllContainers() {
    const api = window.__spectrumAi?.snippet
    const containers = document.querySelectorAll(
      `[data-spectrum-instance-id][data-spectrum-snippet-id="${SNIPPET_ID}"]`,
    )

    if (!api?.bind) {
      // No-bind fallback: SSR'd content remains visible. The auto-fired
      // `snippet:impression` baseline still ships via the bootstrap SDK's
      // viewport observer, but without this snippet's envelope it would
      // miss the per-instance metadata.
      return
    }

    for (const node of containers) {
      api.bind(node, () => {
        // No applyVariant rebuild for this snippet — body HTML is stable
        // for the page lifetime. The callback exists only so bind() can
        // resolve the variant and hand the envelope to the impression
        // baseline. No custom events to wire.
      })
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAllContainers, { once: true })
  } else {
    bindAllContainers()
  }
})()
